<template>
	<b-card-body>
		<div class="row">
			<planned-level-pool v-for="(pool, poolID) in pools" :level="level" :poolID="poolID"  :key="`pools-${level}-${poolID}`"></planned-level-pool>
			<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
				<button class="btn btn-default btn-block" @click="addPools(level)"><i class="fas fa-plus"></i> Add Pool</button>
			</div>
		</div>
	</b-card-body>
</template>

<script>
import PlannedLevelPool from '@/components/planning/PlannedLevelPool.vue'
import ucFirst from "@/mixins/ucfirst.js";

export default {
	mixins: [
		ucFirst,
	],
	props: [
		'level',
	],
	components: {
		PlannedLevelPool
	},
	computed: {
		pools: function(){
			return this.$store.getters['character/pools/poolsAtLevel'](this.level);
		},
	},
}
</script>

<style scoped>

</style>